/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {ReportDashboard} from './page/ReportDashboardPage'

export const ReportLayout: FC = () => <ReportDashboard />
